import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary_km text-primary_km-foreground_km hover:bg-primary_km/90",
        destructive: "bg-destructive_km text-destructive_km-foreground_km hover:bg-destructive_km/90",
        outline: "border_km border_km-input_km bg-background_km hover:bg-accent_km hover:text-accent_km-foreground_km",
        secondary: "bg-secondary_km text-secondary_km-foreground_km hover:bg-secondary_km/80",
        ghost: "hover:bg-accent_km hover:text-accent_km-foreground_km",
        link: "text-primary_km underline-offset-4 hover:underline",
        astrology: "bg-gradient-to-r from-secondary_km to-accent_km text-secondary_km-foreground_km hover:from-secondary_km/90 hover:to-accent_km/90 shadow_km-lg hover:shadow_km-xl transform hover:scale-105 transition-all duration-300 font-semibold",
      },
        size: {
          default: "h-10 px-4 py-2",
          sm: "h-9 rounded-md px-3",
          lg: "h-11 rounded-md px-8",
          xl: "h-12 md:h-14 rounded-lg px-8 md:px-10 text-base md:text-lg",
          icon: "h-10 w-10",
          mobile: "h-12 px-6 py-3 text-base min-w-[44px]",
        },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Button.displayName = "Button";

export { Button, buttonVariants };